import React, { PropsWithChildren, useEffect, useState } from 'react';
import { XEmbed } from 'react-social-media-embed';


/**
 * @interface IEmbedXProps declares any input properties required for this component.
 */
export interface IEmbedXProps extends PropsWithChildren<unknown> {
  url: string;
  postWidth: number | string;
  postHeight: number | string;
}

/**
 * @function EmbedX is a React functional component for displaying a Facebook social media post.
 * @param {} props are the properties passed into the component.
 */
export const EmbedX: React.FC<IEmbedXProps> = (props: IEmbedXProps) => {
  EmbedX.displayName = 'EmbedX';

  // whether to display console logs (displayConsoleLogs && console.log statements)
  const displayConsoleLogs: boolean = false;

  displayConsoleLogs && console.log(`EmbedX. Entered EmbedX`);

  const { url, postWidth, postHeight } = props;

  return (
    <>
      <XEmbed url={url} width={postWidth} height={postHeight} />
    </>
  )
}
